import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useUserPermissions } from '../contexts/UserPermissionsContext';

function TopNavbar({ toggleSidebar }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth0();
  const { userPermissions, isEditor, isAdmin } = useUserPermissions();

  const handleLogout = () => {
    logout({
      logoutParams: { returnTo: window.location.origin },
    });
  };

  return (
    <Navbar className="top-navbar" expand="lg" variant="dark">
      <Container fluid>
        <button
          className="btn btn-link text-white"
          onClick={toggleSidebar}
          style={{ fontSize: '1.5rem', textDecoration: 'none' }}
        >
          ☰
        </button>

        <Navbar.Brand as={Link} to="/dashboard" className=" text-white">
          DoSS - PwD Info
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-lg-center">
            {/* Search Button */}
            <Nav.Link as={Link} to="/search" className="text-white me-2">
              <i className="bi bi-search me-1"></i> Search
            </Nav.Link>

            {/* Register Button - Only for Editors and Admins */}
            {(isEditor || isAdmin) && (
              <Nav.Link as={Link} to="/register" className="text-white me-2">
                <i className="bi bi-person-plus me-1"></i> Register
              </Nav.Link>
            )}

            {/* User Info */}
            <div className="d-flex align-items-center text-white me-3">
              <img
                src={user?.picture}
                alt={user?.name}
                className="rounded-circle me-2"
                width="32"
                height="32"
              />
              <span className="d-none d-lg-inline">{user?.name}</span>
            </div>

            {/* Logout Button */}
            <Button variant="outline-light" size="sm" onClick={handleLogout}>
              <i className="bi bi-box-arrow-right me-1"></i> Logout
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default TopNavbar;
